import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import BET_STATUS_ICON from './bet-status-icon.palette-schema.yaml';

registerTileSchema(BET_STATUS_ICON);

export function generateBetStatusIcon(TILE) {
    return {
        open: icon(TILE.OPEN_BET_ICON_COLOR, 'leg-status-open-icon'),
        lost: icon(TILE.LOST_BET_ICON_COLOR, 'leg-status-lost-icon'),
        void: icon(TILE.VOID_BET_ICON_COLOR, 'leg-status-void-icon'),
        won: icon(TILE.WON_BET_ICON_COLOR, 'leg-status-won-icon'),
        cashedOut: icon(TILE.CASHED_OUT_BET_ICON_COLOR, 'leg-status-cashed-out-icon'),
        saved: icon(TILE.SAVED_BET_ICON_COLOR, 'leg-status-open-icon'),
        placed: icon(TILE.WON_BET_ICON_COLOR, 'leg-status-won-icon'),
    };
}
